import ApiService from '@/services/api.service';

const PatientPortalMessageService = {
    getAll(parameters) {
        const requestData = {
            method: 'get',
            url: '/PatientPortalMessages/',
            headers: {},
            params: parameters,
            paramsSerializer: params => ApiService.parseParams(params)
        };
        return ApiService.customRequest(requestData);
    },

    get(id) {
        return ApiService.get(`/PatientPortalMessages/${id}`);
    },

    add(data) {
        return ApiService.post(`/PatientPortalMessages`, data);
    },

    delete(id) {
        return ApiService.delete(`/PatientPortalMessages/${id}`);
    },

    update(id, data) {
        return ApiService.put(`/PatientPortalMessages/${id}`, data);
    },

    changeMessagesStatus(id, data) {
        return ApiService.put(`/PatientPortalMessages/ChangeMessagesStatus/${id}`, data);
    },

    getNewRequestsCount() {
        return ApiService.get('/PatientPortalMessages/count-new-requests');
    }
};

export default PatientPortalMessageService;
